module.exports = __webpack_public_path__ + "img/130.6.1c0aef2f.png";